import React from 'react';
import { Link } from 'react-router-dom';

const ArticleHero = ({contentType, title, createdOn, imgsrc, customStyle }) => {
    return (
        <>
            <div className='article-hero'>
                <img src={imgsrc || "/images/about/bg8.webp"} alt="" className='w-100' style={{ objectFit: "cover", overflow: "hidden" }} />
                <div className="row position-absolute p-5 w-100" style={{ top: '80px' }}>
                    <div className="col col-12" style={{ backgroundColor: "" }}>
                        <p className="fs-6 text-dark mt-5 fw-bold">
                            {contentType || <span className='placeholder'></span> || "ANNOUNCEMENT"}
                        </p>
                        <h1 className='text-dark title-hero-title mb-4'  style={customStyle?.title}>
                            {title || "Shoora Named Snowflake Media and Entertainment AI Data Cloud Services Partner of the Year 2024"}
                        </h1>
                        <p className='fs-5 text mb-5'><i className='text-lora'>{createdOn || "June 06, 2024"}</i></p>
                        <div className="d-flex pb-5">
                            <button className="btn btn-dark rounded-5">Share</button>
                            <Link className='ms-3 btn btn-link text-dark fw-bold text-decoration-none'></Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ArticleHero